import { useEffect, useState, type ReactNode } from 'react';

/** Returns a src suitable for <img> — filters broken legacy relative storage paths. */
export function resolveTenantLogoSrc(url?: string | null): string | undefined {
  if (!url?.trim()) return undefined;
  const trimmed = url.trim();
  if (
    trimmed.startsWith('data:') ||
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  return undefined;
}

type TenantLogoImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  fallback?: ReactNode;
};

export default function TenantLogoImage({ src, alt, className = '', fallback = null }: TenantLogoImageProps) {
  const resolved = resolveTenantLogoSrc(src);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [resolved]);

  if (!resolved || failed) {
    return <>{fallback}</>;
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
